export default __webpack_public_path__ + "static/header_logo_with_name_slogan-e4e6c146bc650cc5dca13fc252535054.png";